import '../Csss/Loader.css'

const Loader = () => {
  return (
    <div>
        <div className="loader">
            <div className="spinner"></div>
        </div>
    </div>
  )
}

export default Loader
